//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import util from '@/lib/util';
import ImageUploader from "../../components/ImageUploader";

export default {
    name: "complaintRecordInfo",
    components: {ImageUploader},
    data() {
        return {
            id: 0,
            workOrder: {
                id: 0,
                fileIds: [],
                comments: []
            },
            roomNum: '',
            downloadUrl: util.ApiUrl + '/file/download/',
            show: false,
            showComment: false,
            value: ''
        }
    },
    methods: {
        onClickServe() {
            window.location.href = 'tel://400-012-7878'
        },
        getComplaintRecordById() {
            this.loading = true;
            this.$store.dispatch({
                type: 'workOrder/getWorkOrderById',
                id: this.id
            }).then(() => {
                this.workOrder = this.$store.state.workOrder.workOrderInfo;
            }).finally(() => {
                this.loading = false;
            });
        },
        onConfirm() {
            this.onDelete();
        },
        onShowDialog() {
            // this.value = '';
            this.show = true;

        },
        onShowComment() {
            // this.showComment = true;
            // this.$router.push({path: '/complaintComment/' + this.id});
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getComplaintRecordById();
        }
    }
}
